import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerPWA } from "@/pwa/register";
import { startSyncEngine } from "@/pwa/sync-engine";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Phase PWA — register service worker + start the offline-inspection
// sync engine after first paint so we don't compete with hydration.
if (typeof window !== "undefined") {
    window.addEventListener("load", () => {
        registerPWA();
        startSyncEngine();
    });
}
